import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl, toBool } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';
import { useDispatch, useSelector } from 'react-redux';
import { EARLY_CHECKIN, ISINROOMTAB, MOBILE_CHECKIN, PRE_CHECKIN } from '../../config/Constant';
import { formatTime } from '../../js/formatTime';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { CHECK_IN } from '../../navigation/StackNavigator/routes';
import { setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import SliderPressable from '../customPressable/sliderPressable';
import { inAppBrowserFunc } from '../../js/inAppBrowser/inAppBrowser';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { setGuestRoomData } from '../../Redux/Reducers/guestRoomReducer';
import { formatDate } from '../../js/formatDate';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { PreArrivalStateSlider } from '../customPressable/preArrivalStateSlider.js';


const GuestDetailsWidget = (props) => {
  const { widget, listItemData = [], handleOnWidgetClick } = props || {};
  const widgetData = widget.subWidgetMap?.[0]


  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()
  const { t } = useTranslation();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const { isLoggedIn, loggedInRoomNumber } = useSelector(state => state.appConfigSlice);
  const { preCheckInCompleted, preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);
  const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);
  const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice,);

  const { webAppWidgetsInfo, extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
  const dateFormat = extraConfigParam?.DATE_FORMAT;

  const { mobileCheckInConfigs, appConfigs } = webAppWidgetsInfo;

  const { bookYourStayLink, allowUserLoginViaFindingReservation } = appConfigs || {};

  const TIME_FORMAT = useSelector(state => state.deviceConfigSlice?.extraConfigParam?.TIME_FORMAT_MERIDIEM) || false;
  const checkinStartTime = formatTime(mobileCheckInConfigs.checkInStartTime, toBool(TIME_FORMAT))
  const earlyCheckInStartTime = formatTime(mobileCheckInConfigs.earlyCheckInStartTime, toBool(TIME_FORMAT))


  const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);



  const [widgetTitle, setWidgetTitle] = useState()
  const [widgetDescription, setWidgetDescription] = useState()


  let arrival = currentGuestDetails?.checkInDate
  let checkout = currentGuestDetails?.plannedCheckOutDate


  const proceedCheckIn = () => {
    navigation.navigate(CHECK_IN, { attemptCheckin: true });
  }

  const proceedCheckInWidget = () => {
    navigation.navigate(CHECK_IN);
  }

  const handleMakeRes = () => {
    if (bookYourStayLink) {
      inAppBrowserFunc(bookYourStayLink);
    } else {
      dispatch(setRenderFlashMessage(true, { type: "danger", message: "Booking link is unavailable." }));
    }
  }

  const handleLinkToRoom = () => {
    dispatch(setGuestRoomData({
      guestDetails: bookingData,
      activeState: 'get_login_roomnumber'
    }));
    dispatch(setShowLoginModal(true));
  }


  const handleWidgetTitleDescription = async () => {

    const roomID = await AsyncStorage.getItem("roomID");

    if (isLoggedIn) {
      const guestName = currentGuestDetails?.guestName || "";
      const firstName = currentGuestDetails?.guestProfile?.firstName || "";
      const lastName = currentGuestDetails?.guestProfile?.lastName || "";

      setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_logged_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", loggedInRoomNumber))
      setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_logged_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", loggedInRoomNumber))

    } else if (preCheckInCompleted) {

      const guestName = preCheckInData?.guestName || "";
      const firstName = preCheckInData?.firstName || "";
      const lastName = preCheckInData?.lastName || "";


      if (mobileCheckInConfigs.mobileCheckInDisabled) {
        setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_pre_checked_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
        setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_pre_checked_in_checkin_disabled')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
      } else {
        if (preCheckInWidgetState == MOBILE_CHECKIN) {
          setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_pre_checked_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
          setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_pre_checked_in_checkin_open')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
        } else {
          setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_pre_checked_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
          setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", (t('guest_details.widget_description_pre_checked_in_checkin_notopen') + (mobileCheckInConfigs?.earlyCheckInEnabled ? " " + t('guest_details.widget_description_pre_checked_in_checkin_notopen_extent_earlycheckin') : "")))?.replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
        }
      }

    } else if (isBookingFound) {
      const guestName = bookingData?.guestName || "";
      const firstName = bookingData?.firstName || "";
      const lastName = bookingData?.lastName || "";
      setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_booking_found')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))
      setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_booking_found')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace('#checkInStartTime', checkinStartTime).replace('#earlyCheckInStartTime', earlyCheckInStartTime))

    } else if (allowUserLoginViaFindingReservation) {
      setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_find_res')))
      setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_find_res')))

    } else {

      if (ISINROOMTAB) {
        setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_logged_out_inroomapp')))
        setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", (roomID ? t('guest_details.widget_description_logged_out_inroomapp_registerd') : t('guest_details.widget_description_logged_out_inroomapp_notregisterd'))))
      } else {
        setWidgetTitle(widgetData?.widgetTitle?.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_logged_out')))
        setWidgetDescription(widgetData?.widgetDesc?.replace("#MESSAGEFROMAPP", ('guest_details.widget_description_logged_out')))
      }
    }

  }


  useEffect(() => {
    handleWidgetTitleDescription()

   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, preCheckInCompleted, preCheckInData, isBookingFound, bookingData, preCheckInWidgetState])



  const widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
  const customWidgetTitleStyle = getStyles([
    'guestDetailsHeaderTitle',
    `guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId}`,
    `guestDetailsHeaderTitle_${widgetData.id}`
  ]);
  const customWidgetSubTitleStyle = getStyles([
    'guestDetailsHeaderSubtitle',
    `guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`,
    `guestDetailsHeaderSubtitle_${widgetData.id}`
  ]);

  return (
    <View key={widgetData.id} style={getStyles(['guestDetailsWidgetContainer', `guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId}`, `guestDetailsWidgetContainer_${widgetData.id}`])} id={`guestDetailsWidgetContainer guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId} guestDetailsWidgetContainer_${widgetData.id}`} >
      {widgetImg && (
        <ImageComp
          source={widgetImg}
          style={getStyles(['guestDetailsImageStyle', `guestDetailsImageStyle_${widgetData.widgetMetaHtmlId}`, `guestDetailsImageStyle_${widgetData.id}`])}
          id={`guestDetailsImageStyle guestDetailsImageStyle_${widgetData.widgetMetaHtmlId} guestDetailsImageStyle_${widgetData.id}`}
        />
      )}
      {widgetTitle && (
        <RenderHTML
          contentWidth={width}
          baseStyle={customWidgetTitleStyle}
          source={{ html: widgetTitle }}
          systemFonts={[customWidgetTitleStyle.fontFamily]}
          id={`guestDetailsHeaderTitle guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId} guestDetailsHeaderTitle_${widgetData.id}`}
        />
      )}
      {widgetDescription && (
        <View style={customWidgetSubTitleStyle}>
          <RenderHTML
            contentWidth={width}
            baseStyle={customWidgetSubTitleStyle}
            source={{ html: widgetDescription }}
            systemFonts={[customWidgetSubTitleStyle.fontFamily]}
            id={`guestDetailsHeaderSubtitle guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}

          />
        </View>
      )}
      {(arrival && checkout) ?
        <View style={getStyles(['guestDetailsDateContainer'])} id='guestDetailsDateContainer'>
          <View style={getStyles(["guestDetailsDateItemContainer"])} id='guestDetailsDateItemContainer'>
            <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>{formatDate(arrival.split("T")[0], dateFormat)}</Text>
          </View>

          <View style={getStyles(["guestDetailsDateItemContainer", "guestDetailsDateItemDurationContainer"])} id='guestDetailsDateItemContainer guestDetailsDateItemDurationContainer'>
            <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>Duration</Text>
            <Text id='guestDetailsDateItemSubTitle guestDetailsDateItemDurationSubTitle' style={getStyles(['guestDetailsDateItemSubTitle', "guestDetailsDateItemDurationSubTitle"])}>
              {(() => {
                const start = new Date(arrival);
                const end = new Date(checkout);

                start.setHours(0, 0, 0, 0);
                end.setHours(0, 0, 0, 0);

                const diffTime = end - start;
                const nights = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);
                return `${nights} Night${nights !== 1 ? 's' : ''}`;
              })()}
            </Text>
          </View>

          <View style={getStyles(["guestDetailsDateItemContainer"])} id='guestDetailsDateItemContainer'>
            <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>{formatDate(checkout.split("T")[0], dateFormat)}</Text>
          </View>
        </View>
        : null
      }
      {
        isLoggedIn ? null :
          preCheckInCompleted ?
            <View style={getStyles(['guestDetailsButtonContainer'])} id="guestDetailsButtonContainer">
              <PreArrivalStateSlider handleOnSuccess={proceedCheckIn} />

              {!ISINROOMTAB && <>
                <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_room')}</Text>

                <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                  <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.link_to_room')}</Text>
                </CustomPressable>
              </>}
            </View>
            :
            isBookingFound ?
              <View style={getStyles(['guestDetailsButtonContainer'])} id='guestDetailsButtonContainer'>
                <PreArrivalStateSlider handleOnSuccess={proceedCheckInWidget} />

                {!ISINROOMTAB && <>
                  <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_room')}</Text>

                  <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                    <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.link_to_room')}</Text>
                  </CustomPressable>
                </>}
              </View>
              : !ISINROOMTAB &&
              <View style={getStyles(['guestDetailsButtonContainer'])} id='guestDetailsButtonContainer'>
                <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" onPress={() => dispatch(setShowLoginModal(true))}>
                  <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{allowUserLoginViaFindingReservation ? t('guest_details.find_reservation') : t('guest_details.link_to_room')}</Text>
                </CustomPressable>

                {bookYourStayLink &&
                  <>
                    <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_booking')}</Text>

                    <CustomPressable onPress={handleMakeRes} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                      <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.make_reservation')}</Text>
                    </CustomPressable>
                  </>
                }
              </View>
      }
    </View>
  );
};

export default React.memo(GuestDetailsWidget);